export const GLOBAL_API_INSTITUTIONS_ENDPOINTS = {
  getInstitutionsCountries: '/institutions/countries',
  getInstitutionsList: '/institutions',
  getInstitutionDetails: (institutionId: string) =>
    `/institutions/${institutionId}`,
} as const;
